import { useMutation } from '@tanstack/react-query';
import {
  type SaveGradeSetInput,
  gqlClient,
  graphql,
  queryClient,
  resolveBackendError,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { assessmentsKeys } from '../keys';

const saveGradeSet = graphql(/* GraphQL */ `
  mutation assessment_saveGradeSet($input: SaveGradeSetInput) {
    assessment_saveGradeSet(input: $input) {
      id
    }
  }
`);

export function useSaveGradeSet() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: (input: SaveGradeSetInput) =>
      gqlClient.request(saveGradeSet, { input }),
    onSuccess: async (_, { id }) => {
      await queryClient.invalidateQueries({ queryKey: assessmentsKeys.all });
      toast.success(
        id
          ? t('common:snackbarMessages.updateSuccess')
          : t('common:snackbarMessages.createSuccess'),
      );
    },
    onError: async (error) => {
      const description = await resolveBackendError(error);
      toast.error(t('common:snackbarMessages.errorFailed'), { description });
    },
  });
}
